import { GetSubAffiliateResponse } from '../CRM/Responses/SubAffiliateResponse';

import Model from './Model';

export default class SubAffiliate extends Model {
    id: number;
    admin_id: number | null;
    medium: string;
    campaign: string;
    content: string;
    created_at: string | null;
    updated_at: string | null;
    register_count: number = 0;

    constructor(subAffiliate: GetSubAffiliateResponse) {
        super();
        this.assignDataToProps(subAffiliate, [
            'id',
            'admin_id',
            'medium',
            'campaign',
            'content',
            'updated_at',
            'register_count',
        ]);
    }
}
